module.exports = __webpack_public_path__ + "static/media/3_8.0d8ab5f2.png";